export class Error {
	httpStatus: string;
	errorCode: string;
	title: string;
	description: string;
	confirmButtonText: string;
	dismissButtonText: string;
}
